import * as Long from "long";
import { from } from "rxjs";
import { selectBuildingStageInfo } from "../../../../selectors/selectExistingBuildingInfo";
import { selectNotEnoughResourcesMissingResources } from "../../../../selectors/selectNotEnoughResources";
import { actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { IdMissingResourceTypes } from "../../../not-enough-resource/IdMissingResourceTypes";
import { actionOngoingPurchaseStandardSelect } from "../../../ongoing-purchase/actionOngoingPurchase";
export var pathBuildingPurchaseNotEnoughResourceStandard = function (action, state$) {
    var building = action.building;
    var initialStageInfo = selectBuildingStageInfo(building, 0);
    var formattedCost = initialStageInfo.standard.cost.map(function (cost) { return ({
        amount: Long.fromValue(cost.amount),
        typeId: cost.resourceId,
    }); });
    var missingResources = selectNotEnoughResourcesMissingResources(state$.value, formattedCost);
    return from([
        actionOngoingPurchaseStandardSelect([
            {
                missingResources: missingResources,
                missingType: IdMissingResourceTypes.Resources,
            },
        ]),
        actionModalOpen(IdModal.NotEnoughResource),
    ]);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/path/pathBuildingPurchaseNotEnoughResourceStandard.ts
// module id = 2068
// module chunks = 3